import React from 'react';
import { Stack, Button } from '@mui/material';
import { WrapText, CopyAll } from '@mui/icons-material';

interface Props {
  onAddRow: VoidFunction;
  onCopyLast: VoidFunction;
}

export const BottomActionPanel = ({ onAddRow, onCopyLast }: Props) => (
  <Stack direction="row" justifyContent="flex-end">
    <Stack direction="row" justifyContent="center" gap="1rem">
      <Button startIcon={<CopyAll />} size="small" onClick={onCopyLast}>
        Copy last configuration
      </Button>

      <Button startIcon={<WrapText />} size="small" onClick={onAddRow}>
        Add Score Range
      </Button>
    </Stack>
  </Stack>
);
